/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylistV2 } from 'src/core/themes/luisStylist';
import { StyledStack } from 'src/luis/verticals/getStartedGuide/components/GetStartedList';

const messages = defineMessages({
    iterateItemBody: {
        id: 'portal.getStartedList.iterateItemBody',
        defaultMessage: 'After your app has received user queries, apply active learning and features to improve quality.'
    },
    iterateStepOne: {
        id: 'portal.getStartedList.iterateStepOne',
        defaultMessage: 'Review endpoint utterances.'
    },
    iterateSteptwo: {
        id: 'portal.getStartedList.iterateSteptwo',
        defaultMessage: 'Batch test.'
    },
    iterateStepThreeStart: {
        id: 'portal.getStartedList.iterateStepThreeStart',
        defaultMessage: 'Add '
    },
    iterateStepThreePhraseLists: {
        id: 'portal.getStartedList.iterateStepThreePhraseLists',
        defaultMessage: 'phrase lists'
    },
    iterateStepThreeMid: {
        id: 'portal.getStartedList.iterateStepThreeMid',
        defaultMessage: ' and '
    },
    iterateStepThreePatterns: {
        id: 'portal.getStartedList.iterateStepThreePatterns',
        defaultMessage: 'patterns.'
    },
    iterateStepFour: {
        id: 'portal.getStartedList.iterateStepFour',
        defaultMessage: 'Train, Test, and publish.'
    }
});

const urls = {
    reviewEndpoints: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-how-to-review-endoint-utt',
    batchTest: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-how-to-batch-test',
    phraseLists: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-concept-feature',
    patterns: 'https://docs.microsoft.com/azure/cognitive-services/luis/luis-concept-patterns'
};

const { getClassName } = getStylistV2('GetStartedGuide');

const listClassName = getClassName('listClassName', {
    listStylePosition: 'inside',
    marginTop: 18
});

export const IterateListItem = () => {
    const { localize } = useLocalization();

    return (
        <StyledStack>
            {localize(messages.iterateItemBody)}
            <ol className={listClassName}>
                <li>
                    <a href={urls.reviewEndpoints}>{localize(messages.iterateStepOne)}</a>
                </li>
                <li>
                    <a href={urls.batchTest}>{localize(messages.iterateSteptwo)}</a>
                </li>
                <li>
                    <span>
                        {localize(messages.iterateStepThreeStart)}
                        <a href={urls.phraseLists}>{localize(messages.iterateStepThreePhraseLists)}</a>
                        {localize(messages.iterateStepThreeMid)}
                        <a href={urls.patterns}>{localize(messages.iterateStepThreePatterns)}</a>
                    </span>
                </li>
                <li>{localize(messages.iterateStepFour)}</li>
            </ol>
        </StyledStack>
    );
};
